module.exports = __webpack_public_path__ + "img/icon-diary-inactive.da449b7a.png";